import { render, staticRenderFns } from "./KLinearLoader.vue?vue&type=template&id=6d2888a3&scoped=true&"
import script from "./KLinearLoader.vue?vue&type=script&lang=js&"
export * from "./KLinearLoader.vue?vue&type=script&lang=js&"
import style0 from "./KLinearLoader.vue?vue&type=style&index=0&id=6d2888a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2888a3",
  null
  
)

export default component.exports